"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.APSnackbar = void 0;
var _react = _interopRequireDefault(require("react"));
var _Snackbar = _interopRequireDefault(require("@material-ui/core/Snackbar"));
var _Alert = _interopRequireDefault(require("@material-ui/lab/Alert"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _APSnackbar = require("./APSnackbar.styles");
var _faCheckCircle = require("@fortawesome/free-solid-svg-icons/faCheckCircle");
var _faInfoCircle = require("@fortawesome/free-solid-svg-icons/faInfoCircle");
var _faExclamationCircle = require("@fortawesome/free-solid-svg-icons/faExclamationCircle");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var APSnackbar = function APSnackbar(props) {
  var classes = (0, _APSnackbar.useStyles)();
  return /*#__PURE__*/_react["default"].createElement(_Snackbar["default"], _extends({
    className: classes.root
  }, props), /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    style: props.type === 'success' ? {
      backgroundColor: '#55B171'
    } : props.type === 'info' ? {
      backgroundColor: '#1473E6'
    } : props.type === 'warning' ? {
      backgroundColor: '#FFC107'
    } : props.type === 'error' ? {
      backgroundColor: '#D55E5E'
    } : {
      backgroundColor: '#1473E6'
    },
    variant: "filled"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    size: "lg",
    className: classes.icon,
    icon: props.type === 'success' ? _faCheckCircle.faCheckCircle : props.type === 'info' ? _faInfoCircle.faInfoCircle : props.type === 'warning' ? _faExclamationCircle.faExclamationCircle : _faInfoCircle.faInfoCircle
  }), props.message)));
};
exports.APSnackbar = APSnackbar;